import http from '../../Services/api.laravel.http';
var qs = require('qs');

export const LoginService = {
  	login: (formParams) => http.post('/user/login', formParams),
}
